import { render } from "./customer.vue?vue&type=template&id=081cea7f&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"

import "./customer.vue?vue&type=style&index=0&id=081cea7f&scoped=true&lang=css"
import "./customer.vue?vue&type=style&index=1&id=081cea7f&lang=css"
script.render = render
script.__scopeId = "data-v-081cea7f"

export default script